/** Only the last four digits of a bank account are ever shown on screen. */
export function maskedAccount(account: string): string {
  return `${'•'.repeat(Math.max(account.length - 4, 0))}${account.slice(-4)}`;
}
